import React from "react";
import "./RealMapLogo.css";

const RealMapLogo = () => {
  return (
    <div className="realmap-logo-container">
      <div className="realmap-logo">
        <img src="/logo.png" alt="RealMap Logo"  width={70} />
      </div>
    </div>
  );
};

export default RealMapLogo;
